import { CircularProgress, CircularProgressProps } from '@mui/material';

import { FullScreenContainer } from './FullScreenContainer';

export interface LoadingIndicatorProps extends CircularProgressProps {
  /**
   * If `true`, the loading indicator will be wrapped in a full screen container.
   */
  fullScreen?: boolean;
}

export const LoadingIndicator = ({ fullScreen, ...rest }: LoadingIndicatorProps) => {
  if (fullScreen) {
    return (
      <FullScreenContainer transparentBackground>
        <CircularProgress {...rest} sx={{ color: 'background.paper', ...rest.sx }} />
      </FullScreenContainer>
    );
  }
  return <CircularProgress {...rest} />;
};
